<template>
  <b-modal
    id="sendNotifictation"
    ref="sendNotifictation"
    :title="'send_notification' | i18n"
    :ok-title="'send' | i18n"
    :cancel-title="'abort' | i18n"
    ok-variant="primary"
    :ok-disabled="!(notificationModal.title && notificationModal.message)"
    cancel-variant="outline-primary"
    button-size="sm"
    @ok="sendDeviceNotification"
  >
    <text-input
      v-model="notificationModal.title"
      :placeholder="'title' | i18n"
      form-group-id="title-notification"
      :required="true"
    />
    <text-area
      v-model="notificationModal.message"
      :placeholder="'message' | i18n"
      form-group-id="message-notification"
      :required="true"
    />
    <div>
      {{ 'you_will_send_message' | i18n }}
      <div class="owner-wrapper">
        <div
          v-for="row in selectedRows"
          :key="row.id"
          class="owner-block"
        >
          <div>{{ 'employee' | i18n }} : {{ row.belongsToEmployee }}</div><div>App-Id : {{ row.deviceId }}</div>
        </div>
      </div>
    </div>
  </b-modal>
</template>


<script>
import {DeviceMixin, NotificationMixin} from '../../../../mixins';
import TextInput from '../../../inputs/text';
import TextArea from '../../../inputs/textArea';

export default {
  name: 'SendNotification',
  components: {TextInput, TextArea},
  mixins: [DeviceMixin, NotificationMixin],
  props: {
    selectedRows: {
      type: Array,
      default: () => []
    },
  },
  data: function() {
    return {
      notificationModal: {
        title : '',
        message: ''
      },
    };
  },
  methods: {
    async sendDeviceNotification(){
      const devices = this.selectedRows.map(item => item.id);
      const data = {
        ...this.notificationModal,
        devices
      };
      try {
        await this.deviceService.sendNotifications(data);
        this.showNotification({type: 'success', title: this.$translate('send_notification'), message: this.$translate('success')});
        this.notificationModal = {
          title : '',
          message: ''
        };
      } catch (err) {
        this.showNotification({type: 'error', title: this.$translate('send_notification'), message: err.message});
      }
    },
  
  }
};
</script>

<style scoped lang="scss">
  .owner-wrapper{
    display: flex;
    flex-wrap: wrap;
  }

  .owner-block{
    height: 60px;
    display: flex;
    justify-content: center;
    border-radius: 0.2rem;
    box-shadow: 0px 0px 17px -7px rgba(0,0,0,0.35);
    width: fit-content;
    padding: 10px;
    margin: 10px;
    flex-direction: column;
  }

</style>